function checkAndSelectVariantRadio() {
  const currentURL = window.location.href;
  if (!currentURL.includes('products')) return;

  const variantTitle = localStorage.getItem('variant_title');
  if (!variantTitle) return;

  const matchingInputs = document.querySelectorAll(
    `input[type="radio"][data-variant-value="${variantTitle}"]`
  );

  // Exit if no matches found
  if (!matchingInputs.length) return;

  // Uncheck all radio buttons first
  document.querySelectorAll('input[type="radio"]').forEach((input) => {
    input.checked = false;
  });

  // Check only the matching ones
  matchingInputs.forEach((input) => {
    input.checked = true;
  });
}

checkAndSelectVariantRadio();